let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iTi1A")).then(() => parcelRequire('faXQs'));